import React from "react";

const ButtonApply = () => <button type="button" className="rounded-[8px] bg-[#384564] text-[#FFFFFF] py-[18px] px-[30px] mt-10 text-[12px] leading-[16px] font-semibold hover:shadow-[0_4px_4px_rgba(0,0,0,0.25)] transition ease-in-out duration-300">APPLY NOW</button>;

export default ButtonApply;